import {FieldConfig} from '../../dynamic-field/field.config';
import {ValuePositionEnum} from './value-position.enum';
import {NumberTypeEnum} from './number-type.enum';

export interface NumberFieldConfig extends FieldConfig<number> {
    maxValue?: number;
    minValue?: number;
    incrementButtons?: boolean;
    valuePosition?: ValuePositionEnum;
    clearButtonVisibility?: boolean;
    removeSpinners?: boolean;
    inputReadonly?: boolean;
    numberType?: NumberTypeEnum;

}
